import { gql } from "@apollo/client";


export const UPDATE_SHOP_SETTING_SERVICE = gql`
mutation UpdateShopCommissionService($data: ShopSettingCommissionInput!, $where: ShopSettingCommissionWhereInputOne!) {
  updateShopCommissionService(data: $data, where: $where) {
    id
  }
}
`;

export const UPDATE_SHOP = gql`
mutation UpdateShop($data: ShopInput!, $where: ShopWhereInputOne!) {
  updateShop(data: $data, where: $where) {
    id
  }
} 
`;